import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/context/AuthContext';
import { PermissionScopes } from '../../auth/permissions';
import catalog from '../../catalog/Catalog.module.css';
import { CreatePaymentModal } from './CreatePaymentModal';
import styles from '../Payments.module.css';

export const PaymentsLayout: React.FC = () => {
  const { t } = useTranslation('payments');
  const { pathname } = useLocation();
  const { hasPermission } = useAuth();
  const canSettings = hasPermission(PermissionScopes.paymentsSettings);
  const canManage = hasPermission(PermissionScopes.paymentsManage);
  const isList = pathname === '/payments';
  const [createOpen, setCreateOpen] = React.useState(false);

  return (
    <div className={`${catalog.page} ${styles.page}`}>
      <div className={catalog.headerRow}>
        <div>
          <h2 className={catalog.title}>{t('title')}</h2>
          <p className={styles.pageIntro}>{t('subtitle')}</p>
        </div>
        {isList && canManage ? (
          <div className={catalog.headerActions}>
            <button className="btn btn-primary" type="button" onClick={() => setCreateOpen(true)}>
              {t('createPayment')}
            </button>
          </div>
        ) : null}
      </div>
      <nav className={styles.tabBar} aria-label={t('sectionTabsLabel')}>
        <NavLink to="/payments" end className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
          {t('listTitle')}
        </NavLink>
        {canSettings ? (
          <>
            <NavLink to="/payments/settings" className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
              {t('settingsTitle')}
            </NavLink>
            <NavLink to="/payments/automations" className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
              {t('automationsTitle')}
            </NavLink>
          </>
        ) : null}
      </nav>
      <Outlet />
      {createOpen ? (
        <CreatePaymentModal
          onClose={() => setCreateOpen(false)}
          onCreated={() => {
            window.dispatchEvent(new Event('payments-updated'));
          }}
        />
      ) : null}
    </div>
  );
};
